import { Box, Paper, Stack, Typography } from '@mui/material';
import { EqlFieldMetadataReference } from 'generated/graphql';

interface UnifiedFieldSourceFieldTooltipContentProps {
  displayName: string;
  metadataReferences: EqlFieldMetadataReference[];
}

export const UnifiedFieldSourceFieldTooltipContent = ({
  displayName,
  metadataReferences,
}: UnifiedFieldSourceFieldTooltipContentProps) => {
  return (
    <Stack m={1}>
      <Typography variant="body2" pb={1}>
        {displayName}
      </Typography>
      <Paper sx={{ p: 1, maxHeight: 160, overflowY: 'auto' }}>
        <Stack
          direction="column"
          alignItems="start"
          spacing={1}
          justifyContent="center"
        >
          {metadataReferences.map((metadataReference) => {
            return (
              <Stack direction="row" spacing={1} key={metadataReference.key}>
                <Box
                  component="img"
                  width="100%"
                  maxWidth={24}
                  height="auto"
                  sx={{
                    objectFit: 'contain',
                  }}
                  src={metadataReference.iconURL}
                  alt={metadataReference.source}
                />
                <Stack direction="column">
                  <Typography variant="caption">
                    {metadataReference.displayName}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    From {metadataReference.source}
                  </Typography>
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      </Paper>
    </Stack>
  );
};
